/* eslint-disable import/prefer-default-export */
export const DEVICE_COMMENT_MAX_SIZE = 128;
